import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import css from './NewsBlock.module.scss';

import FluidImage from 'components/FluidImage';
import OnScreen from 'components/OnScreen';
import Published from 'components/Published';
import FeatureArticleTag from "components/FeatureArticleTag";

const NewsBlock = ({
    image,
    title,
    intro,
    link,
    published,
    publishedLabel,
    frontpage,
    horizontal,
    onScreen,
    shouldHaveFeatureArticleTag
}) => (
    <div className={cn(css['news-block'], {
        [css.frontpage]: frontpage,
        [css.horizontal]: horizontal,
    })}>
        <a className={css.link} href={link}>
            <FluidImage
                className={css.image}
                image={image}
                visible={onScreen}
            />
            {shouldHaveFeatureArticleTag && <FeatureArticleTag />}
        </a>
        <div className={css.text}>
            <a href={link} className={css.heading}><span>{title}</span></a>
            {intro && <p className={css.paragraph}>{intro}</p>}
            {published && (
                <Published label={publishedLabel} date={published} />
            )}
        </div>
    </div>
);

NewsBlock.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    intro: PropTypes.string,
    published: PropTypes.string,
    link: PropTypes.string.isRequired,
    publishedLabel: PropTypes.string,
    blockId: PropTypes.number,
    frontpage: PropTypes.bool.isRequired,
    onScreen: PropTypes.bool.isRequired,
    horizontal: PropTypes.bool,
    shouldHaveFeatureArticleTag: PropTypes.bool
};

NewsBlock.defaultProps = {
    frontpage: false,
};

export default OnScreen(NewsBlock);



// WEBPACK FOOTER //
// ./src/components/NewsBlock/NewsBlock.jsx